import type { AddFlagProps } from '@databases/flags-types';

import type { ContentTypesFlagProps } from '@canvas/frame-api-types';

import { MentionFlagForMultipleUsers } from './mentionFlagForMultipleUsers';
import { MentionFlagForSingleUser } from './mentionFlagForSingleUser';
import { MentionFlagForTwoUsers } from './mentionFlagForTwoUsers';
import { RestrictionsFlagForMultipleUsers } from './restrictionsFlagForMultipleUsers';
import { RestrictionsFlagForSingleUser } from './restrictionsFlagForSingleUser';
import { RestrictionsFlagForTwoUsers } from './restrictionsFlagForTwoUsers';
import { type MentionBuilder, type BuildProps } from './types';

const MentionBuilderClasses: { new (props: BuildProps): MentionBuilder }[] = [
  MentionFlagForMultipleUsers,
  MentionFlagForSingleUser,
  MentionFlagForTwoUsers,
  RestrictionsFlagForMultipleUsers,
  RestrictionsFlagForSingleUser,
  RestrictionsFlagForTwoUsers,
];

export function buildFlagForMentions(
  props: BuildProps
): (AddFlagProps & ContentTypesFlagProps)[] {
  const flagData = [];
  for (const MentionBuilder of MentionBuilderClasses) {
    const mentionBuilder = new MentionBuilder(props);

    if (!mentionBuilder.shouldShowFlag()) {
      continue;
    }

    const buildFlagData = mentionBuilder.build();

    flagData.push({
      ...buildFlagData,
      close: 'auto' as const,
    });
  }

  return flagData;
}
